// extracted by mini-css-extract-plugin
export var csatScore = "_lv-5";
export var header = "_lv-1";
export var panelWrapper = "_lv-2";
export var postPreview = "_lv-3";
export var rightContent = "_lv-0";
export var wrappingText = "_lv-4";